import React, { useState, useEffect } from 'react';
import { useTable } from 'react-table';
import Pagination from '../../../components/shared/pagination/index';
import { RiDeleteBin5Line, RiPencilLine } from "react-icons/ri";
import '../../../../src/index.css';
import { getProductsCategory, deleteProductCategoryId, createProductCategory, updateProductCategoryId } from '../../../client/administration/products/productCategory/index';
import buttonClose from "../../../assets/images/shared/modals/button-close.svg";
import { RiAddFill } from "react-icons/ri";
import AddData from '../../../components/shared/alertRegisterData/index';
import DeleteData from '../../shared/alertDeleteData/index';
import EditData from 'components/shared/alertEditData';
import InputField from 'components/forms/inputField';

const TableCategoryProduct = ({ recordsPerPage, data, filterCategory, currentPage, setCurrentPage,  showModalAddCategory, closeModalAddCategory,searchTerm,  onSearchTermChange }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [categoryName, setCategoryName] = useState('');
  const [createdAt, setCreatedAt] = useState(new Date().toLocaleString());
  const [showModalAddData, setShowModalAddData] = useState(false);
  const [showModalDeleteData, setShowModalDeleteData] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const totalRecords = categories.length;
 
  const [editingCategory, setEditingCategory] = useState(null); 
  const [showEditConfirmModal, setShowEditConfirmModal] = useState(false);
  const [showModalEditCategory, setShowModalEditCategory] = useState(false);

  const [editedCategory, setEditedCategory] = useState({
    id: '',
    categoryName: '',
  });

  const [errors, setErrors] = useState({
    categoryName: false,
  });

  const handleEditCategoryClick = (row) => {
    setEditingCategory(row);
    setEditedCategory({
      id: row.original.id,
      categoryName: row.original.categoryName,
    });
    console.log(row.original);
  };
  const handleCategoryInputChange = (e) => {
    const { name, value } = e.target;
    setEditedCategory((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleCategoryEditSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {
      categoryName: !editedCategory.categoryName || editedCategory.categoryName.length < 3 || editedCategory.categoryName.length > 45,
    };
    setErrors(newErrors);
    if (Object.values(newErrors).some(error => error)) {
        return;
    }
    setShowEditConfirmModal(true);
  };

  const closeModalAddData = () => {
    setShowModalAddData(false);
  };
  const closeModalDeleteData = () => {
    setShowModalDeleteData(false);
  };

  const fetchCategories = async () => {
    try {
      const { data } = await getProductsCategory();
      setCategories(data);
    } catch (err) {
      setError(err.message || "Error al cargar las categorías");
    } finally {
      setLoading(false);
    }
  };
 
  useEffect(() => {
      const filteredData = data.filter(category => {
        const matchesCode = filterCategory ? category.categoryName.includes(filterCategory) : true;
        const matchesSearchTerm = searchTerm
        ? category.categoryName.toLowerCase().includes(searchTerm.toLowerCase())
        : true;

        return matchesCode && matchesSearchTerm;
      });
  
      setCategories(filteredData);
      setLoading(false);
  }, [data, filterCategory, searchTerm]); 

  const totalPages = Math.ceil(totalRecords / recordsPerPage);

  const changePage = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleDeleteCategory = async () => {
    if (!categoryToDelete) return;

    try {
      await deleteProductCategoryId(categoryToDelete.id);
      setCategories(categories.filter(category => category.id !== categoryToDelete.id));
      setCategoryToDelete(null);
      setShowModalDeleteData(false);
    } catch (err) {
      setError("Error al eliminar la categoría: " + err.message);
    }
  };

  const handleSaveCategory = async () => {
    const newErrors = {
      categoryName: !categoryName || categoryName.length < 3 || categoryName.length > 45,
    };

    setErrors(newErrors);
    // Si hay algún error, no continuar
    if (Object.values(newErrors).some(error => error)) {
      return;
    }

    const newCategory = {
      categoryName: categoryName,
      createdAt: new Date().toISOString(),
    };

    try {
      const { data } = await createProductCategory(newCategory);
      setCategories((prevCategories) => [...prevCategories, data]);
      setCategoryName('');
      //setShowModalAddCategory(false);
      closeModalAddCategory();
      setShowModalAddData(true);
      fetchCategories();
      onSearchTermChange(searchTerm);
    } catch (err) {
      setError("Error al agregar la categoría: " + err.message);
      alert("Hubo un error al agregar la categoría.");
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: '#',
        accessor: 'id',
        style: { width: '30px' },
        Cell: ({ value }) => <div style={{ textAlign: 'center' }}>{value}</div>,
      },
      {
        Header: 'Categoría',
        accessor: 'categoryName',
        style: { width: '260px' },
        Cell: ({ value }) => (
          <div style={{ textAlign: 'center' }} >
            {value}
          </div>
        ),
      },
      {
        Header: 'Fecha de Registro',
        accessor: 'createdAt',
        style: { width: '200px' },
        Cell: ({ value }) => (
          <div style={{ textAlign: 'center' }} >
            {new Date(value).toLocaleString()}
          </div>
        ),
      },
      {
        Header: 'Editar',
        accessor: 'editar',
        style: { width: '90px' },
        Cell: ({ row }) => (
          <div className="flex items-center justify-center" style={{ textAlign: 'center' }}>
            <button
              onClick={() => handleEditCategoryClick(row)}
              className="p-2 flex justify-center items-center bg-[#EFEEF7] hover:bg-[#D8D7E0] rounded-[4px] border border-[#D9D9D9] w-12 h-12"
            >
              <RiPencilLine className="text-xl text-black" />
            </button>
          </div>
        ),
      },
      {
        Header: 'Eliminar',
        accessor: 'eliminar',
        style: { width: '90px' },
        Cell: ({ row }) => (
          <div className="flex items-center justify-center" style={{ textAlign: 'center' }}>
            <button
              onClick={() => {
                setCategoryToDelete({ id: row.original.id, name: row.original.categoryName });
                setShowModalDeleteData(true);
              }} 
              className="p-2 flex justify-center items-center bg-[#EFEEF7] hover:bg-[#D8D7E0] rounded-[4px] border border-[#D9D9D9] w-12 h-12"
            >
              <RiDeleteBin5Line className="text-xl text-black" />
            </button>
          </div>
        ),
      },
    ],
    []
  );

  const indexOfLastCategory = currentPage * recordsPerPage;
  const indexOfFirstCategory = indexOfLastCategory - recordsPerPage;
  const currentCategories = categories.slice(indexOfFirstCategory, indexOfLastCategory);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data: currentCategories });

 //if (loading) return <p>Cargando datos...</p>;
 if (error) {
  return (
    <div className='items-center justify-center w-full min-h-full pt-16'>
      <p className='pt-4 text-2xl text-center text-error font-itcmedium'>
        Hubo un error al recuperar los datos.
      </p>
    </div>
  );
}
  return (
    <div className="w-full pt-4">
      {/*</div><div className=''>
        <button
          onClick={openModalAddCategory}
          className="flex items-center justify-center h-[40px] p-3 px-5 mb-4 space-x-4 text-white rounded-md bg-green"
          >
          <RiAddFill className="flex text-[14px] font-itcmedium" /> 
          Agregar categoría de producto
        </button>

      */}
      {!error && categories.length === 0 && (
        <div className='flex items-center justify-center w-full'>
         <p className='pt-4 text-xl text-center font-itcmedium'>No se hallaron registros.</p>
        </div>

      )}
    

      {/* Modal de agregar categoría */}
      {showModalAddCategory && (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
          <div className="lg:w-[40%] w-[90%] h-auto p-2 bg-white rounded-3xl shadow-lg flex flex-col">
            <div className="flex justify-end">
              <button
                onClick={closeModalAddCategory}
                className="px-1 py-0 rounded-md"
              >
                <img src={buttonClose} />
              </button>
            </div>
            <div className="flex flex-col items-center justify-center px-4 pb-4 space-y-4">
              <div className="flex justify-center w-full">
                <h1 className="mb-4 text-2xl text-blue font-itcbold">Agregar categoría de producto</h1>
              </div>
              <div className="justify-center flex flex-col gap-4 w-[85%]">
                  <InputField
                    value={categoryName}
                    placeholder="Nombre de la categoría"
                    onChange={(e) => {
                      setCategoryName(e.target.value);
                      setErrors(prevErrors => ({ ...prevErrors, categoryName: false }));
                    }}
                    error={errors.categoryName}
                    errorMessage= "Campo requerido"
                    minLength={3}
                    maxLength={45}
                    required
                  />
              </div>
            </div>
            <div className="flex w-full py-4 sm:px-[7.5%] justify-between gap-2">
            <button 
                onClick={handleSaveCategory}
                className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center text-white bg-green rounded-2xl font-itcdemi"
              >
                Guardar
              </button>
              <button
                onClick={closeModalAddCategory}
                className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center bg-white border-2 text-green rounded-2xl font-itcdemi border-green"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Modal de éxito */}
      <AddData showModalAddData={showModalAddData} closeModalAddData={closeModalAddData} />

      {/* Modal de editar categoría */}
      {editingCategory && (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
          <div className="lg:w-[40%] w-[90%] h-auto p-2 bg-white rounded-3xl shadow-lg flex flex-col">
            <div className="flex justify-end">
              <button
                onClick={() => setEditingCategory(null)}
                className="px-1 py-0 rounded-md"
              >
                <img src={buttonClose} alt="Cerrar"/>
              </button>
            </div>
            <div className='flex flex-col items-center justify-center px-4 pb-4 space-y-4'>
              <div className='flex justify-center w-full'>
                <h1 className="mb-4 text-2xl font-bold text-blue font-itcbold">Editar categoría</h1>
              </div>
              <form onSubmit={handleCategoryEditSubmit} className=' w-[85%] justify-center' >
              <div className='flex flex-col gap-4'>
                  <InputField
                    value={editedCategory.categoryName}
                    placeholder="Nombre de la categoría"
                    onChange={(e) =>
                      setEditedCategory((prevState) => ({
                        ...prevState,
                        categoryName: e.target.value,
                      }))
                    }
                    error={errors.categoryName}
                    errorMessage="Campo requerido"
                    minLength={3}
                    maxLength={45}
                    required
                  />
                </div>
                <div className="flex justify-between w-full gap-2 py-4 pt-8">
                  <button 
                    type="submit"
                    className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center text-white bg-green rounded-2xl font-itcdemi">
                      Guardar
                  </button> 
                  <button type="button"
                    onClick={() => setEditingCategory(null)}
                    className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center bg-white border-2 text-green rounded-2xl font-itcdemi border-green">
                      Cancelar
                  </button>   
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {showEditConfirmModal && (
        <EditData
          showModalEditData={showEditConfirmModal}
          closeModalEditData={() => setShowEditConfirmModal(false)}
          categoryName={editedCategory.categoryName}
          context="Categoria"
          onConfirm={async () => {
            try {
              await updateProductCategoryId(editedCategory.id, {
                categoryName: editedCategory.categoryName,
              });
              const { data: updatedCategories } = await getProductsCategory();
              setCategories(updatedCategories);
              setEditingCategory(null);
              setShowEditConfirmModal(false); 
            } catch (err) {
              setError("Error al actualizar el registro: " + err.message);
              alert("Hubo un error al intentar actualizar el registro.");
            }
          }}
        />
      )}

      {/* Modal de eliminación */}
      {showModalDeleteData && (
        <DeleteData
          showModalDeleteData={showModalDeleteData}
          closeModalDeleteData={() => setShowModalDeleteData(false)}
          categoryName={categoryToDelete?.id} 
          context="Categorías"
          confirmDelete={handleDeleteCategory}
        />
      )}

      {categories.length > 0 && (
        <>
          {/* Tabla de categorías de productos */}
          <div className="max-w-full overflow-x-auto scroll-container">
            <table {...getTableProps()} className="w-full border-collapse table-fixed">
              <thead className="bg-white">
                {headerGroups.map(headerGroup => (
                  <tr {...headerGroup.getHeaderGroupProps()} className="text-sm text-center font-itcbold">
                    {headerGroup.headers.map(column => (
                      <th
                        {...column.getHeaderProps()}
                        style={column.style}
                        className="px-4 py-2 border border-[#D9D9D9]"
                      >
                        {column.render('Header')}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()} className="table-row-group">
                {rows.map(row => {
                  prepareRow(row);
                  return (
                    <tr
                      {...row.getRowProps()}
                      className={`text-sm border-collapse h-full font-itcmedium text-left ${row.index % 2 === 0 ? 'bg-white' : 'bg-[#EBEBEB]/[0.2]'}`}
                    >
                      {row.cells.map(cell => (
                        <td
                          {...cell.getCellProps()}
                          style={cell.column.style}
                          className="px-4 py-2 border border-[#D9D9D9]"
                        >
                          {cell.render('Cell')}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="flex flex-col items-center justify-between mt-6 space-x-4 space-y-2 md:flex-row">
            <p className="text-[#1F2A37] text-sm font-itcbook">
              Mostrando registros del {(currentPage - 1) * recordsPerPage + 1} al{' '}
              {Math.min(currentPage * recordsPerPage, totalRecords)} de un total de {totalRecords} registros
            </p>
            <Pagination currentPage={currentPage} totalPages={totalPages} changePage={changePage} />
          </div>
        </>
      )}
    </div>
  );
};

export default TableCategoryProduct;
